
import ApiService from './ApiService'

class OrganisationService {
  addOrganisation = async (apiToken, data) => {
    var url = '/admin/organisation'

    // var params = {
    //   fields: 'id,firstName,lastName,email,userName',
    //   limit: 1000
    // }

    var params = {}

    var options = {
      data: data
    }

    try {
      var result = await ApiService.post(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  getOrganisations = async (apiToken, params) => {
    var url = '/admin/organisation'

    // var params = {
    //   fields: 'id,name,appSettings,enabledModules'
    // }

    try {
      var organisations = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return organisations
  }

  getOrganisation = async (apiToken, customParams = {}, organisationId) => {
    var url = `/admin/organisation/${organisationId}`

    var params = {
      fields: 'id,name,primaryColour,secondaryColour,logoUrl,createdAt',
      limit: 1,
      ...customParams
    }

    try {
      var organisation = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return organisation
  }

  updateOrganisation = async (apiToken, data, orgId) => {
    var url = `/admin/organisation/${orgId}`

    // var params = {
    //   fields: 'id,firstName,lastName,email,userName',
    //   limit: 1000
    // }

    var params = {}

    var options = {
      data: data
    }

    try {
      var result = await ApiService.put(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  getUsers = async (apiToken, params, organisationId) => {
    var url = `/admin/organisation/${organisationId}/user`

    
    params.fields = 'id,firstName,lastName,email,type'



    try {
      var users = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return users
  }

  getStudents = async (apiToken, params, organisationId) => {
    var url = `/admin/organisation/${organisationId}/student`

    
    params.fields = 'id,firstName,lastName,reference,type,createdAt'



    try {
      var users = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return users
  }

  getRolesForOrg = async (apiToken, organisationId) => {
    var url = `/admin/organisation/${organisationId}/role`

    var params = {
      fields: 'id,title,permissions'
    }

    try {
      var roles = await ApiService.get(apiToken, url, params)
    } catch (err) {
      console.error(err)
    }
    return roles
  }

  deleteOrg = async (apiToken, data) => {
    const orgId = data.id
    var url = `/admin/organisation/${orgId}`

    var params = {}

    var options = {}
    try {
      var result = await ApiService.sendDelete(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  setOrganisationAdmin = async (apiToken, organisationId, data) => {

    if (!organisationId) {
      throw Error('No organisationId supplied')
    }

    var url = `/admin/organisation/${organisationId}/admin`

    var params = {}

    var options = {
      data: data
    }

    try {
      var result = await ApiService.put(apiToken, url, params, options)
    } catch (err) {
      console.error(err)
    }
    return result
  }

  addCpomsToken = async (apiToken, orgId, token) => {
      let url = `/admin/cpoms/add-token/${orgId}`

      let params = {}
      let body = {
          token: token
      }

      try {
          var response = await ApiService.post(apiToken, url, params, body)
      } catch (err) {
          console.error(err)
          return {
              error: 'Error adding token to Cpoms: ' + err.message
          }
      }
      return response
  }
}
export default new OrganisationService()
